import { create } from "zustand";
// format data for slider value label

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
const formatCurrency = (value) => {
  if (!value) value = 0;
  return formatter.format(value);
};

export const useCaseListStore = create((set) => ({
  filterUI: null,

  setFilterUI: (nextFilterUI) => {
    set(() => ({
      filterUI: nextFilterUI,
      chipList: [],
    }));
  },
  setSearchValue: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          selectedValue: fieldValue,
        },
      },
    }));
  },
  setRangeSliderMinValue: (fieldName, fieldValue) => {
    set((state) => {
      return {
        filterUI: {
          ...state.filterUI,
          [fieldName]: {
            ...state.filterUI[fieldName],
            currentValues: {
              ...state.filterUI[fieldName].currentValues,
              __gte: fieldValue,
            },
            activeChip: {
              isActive: fieldValue ? true : false,
            },
          },
        },
      };
    });
  },
  setRangeSliderMaxValue: (fieldName, fieldValue) => {
    set((state) => {
      return {
        filterUI: {
          ...state.filterUI,
          [fieldName]: {
            ...state.filterUI[fieldName],
            currentValues: {
              ...state.filterUI[fieldName].currentValues,
              __lte: fieldValue,
            },
            activeChip: {
              isActive: fieldValue ? true : false,
            },
          },
        },
      };
    });
  },
  setShowForm: (fieldName, fieldValue) => {
    set((state) => {
      return {
        filterUI: {
          ...state.filterUI,
          [fieldName]: {
            ...state.filterUI[fieldName],
            showForm: fieldValue,
          },
        },
      };
    });
  },
  setMultiSelectSearchOptions: (fieldName, fieldValue) => {
    set((state) => {
      return {
        filterUI: {
          ...state.filterUI,
          [fieldName]: {
            ...state.filterUI[fieldName],
            options: fieldValue,
          },
        },
      };
    });
  },
  setMultiSelectSearchSelectedItems: (fieldName, fieldValue) => {
    set((state) => {
      return {
        filterUI: {
          ...state.filterUI,
          [fieldName]: {
            ...state.filterUI[fieldName],
            selectedValue: fieldValue,
            //checked: fieldValue,
            activeChip: {
              isActive: fieldValue && fieldValue.length > 0 ? true : false,

              label:
                 fieldValue.map((itm) => {
                  if (itm.name) return itm.name;
                  if (itm.label) return itm.label;
                  if (itm.reason) return itm.reason;
                  return itm;
                })
                .join(", ")
            },
          },
        },
      };
    });
  },
  setMultiSelectSearchCheckedItems: (fieldName, fieldValue) => {
    set((state) => {
   /*    const currentIndex =
        state.filterUI[fieldName].checked.indexOf(fieldValue);
      const newChecked = [...state.filterUI[fieldName].checked];
      if (currentIndex === -1) {
        newChecked.push(fieldValue);
      } else {
        newChecked.splice(currentIndex, 1);
      } */
      return {
        filterUI: {
          ...state.filterUI,
          [fieldName]: {
            ...state.filterUI[fieldName],
            selected: fieldValue,
            checked: fieldValue,
            activeChip: {
              isActive: fieldValue.length > 0 ? true : false,

              label:fieldValue.map((itm) => {
                if (itm.name) return itm.name;
                if (itm.label) return itm.label;
                if (itm.reason) return itm.reason;
                return itm;
              })
              .join(", "),
            },
          },
        },
      };
    });
  },
  setDashboardWidgetItems: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          dashboardWidgetSelections: fieldValue,
        },
      },
    }));
  },
  setSearchOptionGroup: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          selectedValue: fieldValue,
          activeChip: {
            isActive: fieldValue ? true : false,
            label: fieldValue,
          },
        },
      },
    }));
  },
  setSingleSelectGroup: (fieldName, fieldValue, fieldLabel) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          selectedValue: fieldValue,
          activeChip: {
            isActive: fieldValue ? true : false,
            label: fieldLabel,
          },
        },
      },
    }));
  },
  setDatePickerFilter: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          selectedValue: fieldValue,
          activeChip: {
            isActive: fieldValue ? true : false,
          },
        },
      },
    }));
  },
  setDateRangeFrom: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          currentValues: {
            ...state.filterUI[fieldName].currentValues,
            __gte: fieldValue,
          },
          activeChip: {
            isActive: fieldValue ? true : false,
            label: fieldValue ? fieldValue : new Date().toLocaleDateString(),
          },
        },
      },
    }));
  },
  setDateRangeTo: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          currentValues: {
            ...state.filterUI[fieldName].currentValues,
            __lte: fieldValue,
          },
          activeChip: {
            isActive: fieldValue ? true : false,
            label: fieldValue ? fieldValue : new Date().toLocaleDateString(),
          },
        },
      },
    }));
  },
  setChipActive: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          activeChip: {
            ...state.filterUI[fieldName].activeChip,
            isActive: fieldValue,
          },
        },
      },
    }));
  },
  setActiveChipLabel: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          activeChip: {
            ...state.filterUI[fieldName].activeChip,
            label: fieldValue,
            isActive: fieldValue && fieldValue.length > 0 ? true : false,
          },
        },
      },
    }));
  },
  setChipDeactive: (fieldName, fieldValue) => {
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          activeChip: {
            ...state.filterUI[fieldName].activeChip,
            isActive: fieldValue && fieldValue.length > 0 ? true : false,
          },
        },
      },
    }));
    set((state) => ({
      filterUI: {
        ...state.filterUI,
        [fieldName]: {
          ...state.filterUI[fieldName],
          selectedValue: fieldValue,
          checked: [],
        },
      },
    }));
  },
}));